module.exports = __webpack_public_path__ + "static/img/11.b632ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/11.png
// module id = l6ye
// module chunks = 1